export { default } from './Vendors'; 